export const parserSnakeCaseToCamelCase = (data: any) => {
  if (!data) return data;
  return Object.keys(data).reduce((acc, key) => {
    const newKey = key.replace(/_(\w)/g, (match, p1) => p1.toUpperCase());
    return { ...acc, [newKey]: data[key] };
  }, {});
};
